// extracted by mini-css-extract-plugin
export default {"Wrapper":"AppLayout_Wrapper__XbWRa","active":"AppLayout_active__AfFrG","main":"AppLayout_main__yUJdJ","container":"AppLayout_container__+mgcO"};